"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-result", {
    attrs: {
      status: "403",
      title: "没有访问权限",
      "sub-title": "您的访问请求被拒绝了哦，请联系管理员吧！"
    },
    scopedSlots: _vm._u([{
      key: "extra",
      fn: function () {
        return [_c("a-button", {
          attrs: {
            type: "primary"
          },
          on: {
            click: _vm.toHome
          }
        }, [_vm._v(" 返回首页 ")])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;